import React from 'react';

import readinessSvg from '@backrs_ui/grow-ui/src/assets/images/gpa-guide/readiness.svg';
import { GUIDE_TEXT_MAX_WIDTH } from '@backrs_ui/grow-ui/src/components/GuidePage';
import type { GpaGuideBroaderValue } from '@backrs_ui/grow-ui/src/pages/GpaGuide/content/types';

import { Box, SxProps, Theme, Typography } from '@mui/material';

type BroaderValueSectionProps = Readonly<{
  content: GpaGuideBroaderValue;
}>;

export const BroaderValueSection: React.FC<BroaderValueSectionProps> = ({ content }) => (
  <Box sx={containerSx}>
    <Typography variant="text-md-regular" sx={introSx}>
      {content.intro}
    </Typography>

    <Box sx={rowSx}>
      <Box sx={listSx}>
        {content.items.map((item) => (
          <Box key={item.label} sx={itemSx}>
            <Typography variant="text-md-semibold" sx={labelSx}>
              {item.label}
            </Typography>
            <Typography variant="text-sm-regular" sx={descriptionSx}>
              {item.description}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box
        component="img"
        src={readinessSvg}
        alt="A thoughtful approach to GPA is about readiness, not just credentials."
        sx={imageSx}
      />
    </Box>
  </Box>
);

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xl'],
});

const introSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
  maxWidth: GUIDE_TEXT_MAX_WIDTH,
});

const rowSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-3xl'],
  alignItems: 'flex-start',
  '@container (min-width: 600px)': {
    flexDirection: 'row',
    gap: backrs.spacing['spacing-4xl'],
  },
});

const listSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xl'],
  flex: '1 1 50%',
  minWidth: 0,
});

const itemSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-sm'],
});

const labelSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
});

const descriptionSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});

const imageSx: SxProps<Theme> = {
  width: '100%',
  height: 'auto',
  flex: '1 1 50%',
  minWidth: 0,
  objectFit: 'contain',
};
